module.exports = __webpack_public_path__ + "img/photo-temporaire.f7366d31.jpg";